  let slides = [
    {
      quote: "testimonials.text1",
      author: "testimonials.author1",
    },
    {
      quote: "testimonials.text2",
      author: "testimonials.author2",
    },
    {
      quote: "testimonials.text3",
      author: "testimonials.author3",
    },
    {
      quote: "testimonials.text4",
      author: "testimonials.author4",
    },
  ]


export default slides;